var _g, _circle, _g2, _g3, _g4, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTzg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.302 1.34c.706-1.389 2.69-1.389 3.396 0l.734 1.445a1.905 1.905 0 0 0 3.046.482l1.146-1.147c1.1-1.103 2.987-.49 3.23 1.05l.251 1.6a1.905 1.905 0 0 0 2.748 1.4l1.444-.737c1.387-.708 2.992.458 2.747 1.996L46.79 9.03a1.905 1.905 0 0 0 2.18 2.18l1.602-.254c1.538-.245 2.704 1.36 1.996 2.747l-.738 1.444a1.905 1.905 0 0 0 1.4 2.748l1.602.252c1.539.242 2.152 2.129 1.049 3.23l-1.147 1.145a1.905 1.905 0 0 0 .482 3.046l1.445.734c1.389.706 1.389 2.69 0 3.396l-1.445.735a1.905 1.905 0 0 0-.482 3.045l1.147 1.146c1.103 1.1.49 2.987-1.05 3.23l-1.6.251a1.905 1.905 0 0 0-1.4 2.748l.737 1.444c.708 1.387-.458 2.992-1.996 2.747l-1.601-.255a1.905 1.905 0 0 0-2.18 2.18l.254 1.602c.245 1.538-1.36 2.704-2.747 1.996l-1.444-.738a1.905 1.905 0 0 0-2.748 1.4l-.252 1.602c-.242 1.539-2.129 2.152-3.23 1.049l-1.145-1.147a1.905 1.905 0 0 0-3.046.482l-.734 1.445c-.706 1.389-2.69 1.389-3.396 0l-.735-1.445a1.905 1.905 0 0 0-3.046-.482l-1.145 1.147c-1.1 1.103-2.987.49-3.23-1.05l-.251-1.6a1.905 1.905 0 0 0-2.748-1.4l-1.444.737c-1.387.708-2.992-.458-2.747-1.996l.255-1.601a1.905 1.905 0 0 0-2.18-2.18l-1.602.254c-1.538.245-2.704-1.36-1.996-2.747l.738-1.444a1.905 1.905 0 0 0-1.4-2.748l-1.602-.252c-1.539-.242-2.152-2.129-1.049-3.23l1.147-1.145a1.905 1.905 0 0 0-.482-3.046l-1.445-.734c-1.389-.706-1.389-2.69 0-3.396l1.445-.735a1.905 1.905 0 0 0 .482-3.046L4.12 21.377c-1.103-1.1-.49-2.987 1.05-3.23l1.6-.251a1.905 1.905 0 0 0 1.4-2.748l-.737-1.444c-.708-1.387.458-2.992 1.996-2.747l1.601.255a1.905 1.905 0 0 0 2.18-2.18l-.254-1.602c-.245-1.538 1.36-2.704 2.747-1.996l1.444.738a1.905 1.905 0 0 0 2.748-1.4l.252-1.602c.242-1.539 2.129-2.152 3.23-1.049l1.145 1.147a1.905 1.905 0 0 0 3.046-.482l.734-1.445Z",
    fill: "#5E7DA0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 28,
    r: 21.429,
    fill: "#124279"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    fill: "#FFCC18"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.476,
    cy: 41.809,
    r: 1.429
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.238,
    cy: 41.809,
    r: 1.429
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 41.809,
    r: 1.429
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.762,
    cy: 41.809,
    r: 1.429
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.524,
    cy: 41.809,
    r: 1.429
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.524 51.81c-2.1 0-3.81-1.71-3.81-3.81s1.71-3.81 3.81-3.81 3.81 1.71 3.81 3.81-1.71 3.81-3.81 3.81Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.092 38-.932-.147c-1.539-.242-2.152-2.129-1.05-3.23l1.148-1.145a1.905 1.905 0 0 0-.483-3.046l-1.445-.734A1.883 1.883 0 0 1 2.29 28h55.4c0 .672-.347 1.345-1.041 1.698l-1.445.735a1.905 1.905 0 0 0-.483 3.045l1.148 1.146c1.102 1.1.489 2.987-1.05 3.23l-.932.146H6.092Z",
    fill: "#F09103"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.524 43.238A4.764 4.764 0 0 0 44.762 48a4.764 4.764 0 0 0 4.762 4.762A4.764 4.764 0 0 0 54.286 48a4.764 4.764 0 0 0-4.762-4.762ZM50 46.571v-.952h-.952v.952H50Zm0 3.81v-2.857h-.952v2.857H50ZM45.714 48c0 2.1 1.71 3.81 3.81 3.81s3.81-1.71 3.81-3.81-1.71-3.81-3.81-3.81-3.81 1.71-3.81 3.81Z",
    fill: "#5E7DA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.955 12v.894h-1.367v3.963h-1.127v-3.963h-1.366V12h3.86Zm5.055 2.427c0 .351-.06.678-.183.98a2.36 2.36 0 0 1-.51.79c-.22.222-.485.397-.797.524a2.7 2.7 0 0 1-1.03.19 2.73 2.73 0 0 1-1.033-.19 2.392 2.392 0 0 1-.8-.524 2.4 2.4 0 0 1-.513-.79 2.631 2.631 0 0 1-.18-.98c0-.351.06-.678.18-.98.122-.302.293-.564.513-.786.222-.223.489-.397.8-.524.311-.127.656-.19 1.034-.19.377 0 .72.065 1.03.194.31.126.576.3.796.523.22.222.39.484.51.787.122.302.184.627.184.976Zm-1.153 0c0-.24-.031-.455-.093-.646a1.356 1.356 0 0 0-.27-.49 1.142 1.142 0 0 0-.427-.307 1.475 1.475 0 0 0-.576-.107c-.218 0-.413.036-.584.107a1.172 1.172 0 0 0-.43.306 1.385 1.385 0 0 0-.267.49 2.084 2.084 0 0 0-.093.647c0 .242.031.46.093.654.063.19.152.353.267.486.118.133.261.236.43.307.171.069.366.103.584.103.215 0 .407-.034.576-.103a1.15 1.15 0 0 0 .427-.307 1.36 1.36 0 0 0 .27-.486c.062-.194.093-.412.093-.654Zm2.819.807v1.623h-1.127v-4.856h1.714c.342 0 .635.04.88.123.246.08.448.19.606.333.16.142.278.31.353.503.076.194.114.403.114.627 0 .242-.039.465-.117.667a1.338 1.338 0 0 1-.356.52c-.16.144-.364.258-.61.34-.245.08-.535.12-.87.12h-.587Zm0-.85h.587c.293 0 .504-.07.633-.21.129-.14.193-.336.193-.587a.878.878 0 0 0-.05-.303.654.654 0 0 0-.41-.387 1.122 1.122 0 0 0-.367-.053h-.586v1.54Zm-8.926 4.535v.581a.714.714 0 0 1-.043.243.861.861 0 0 1-.11.224l-3.257 4.652h3.305v1.238h-5.352v-.619a.752.752 0 0 1 .143-.414l3.266-4.667H20.56V18.92h5.19Zm2.498 6.938H26.63V18.92h1.62v6.938Zm2.137-6.938c.07 0 .128.003.176.01.048.006.09.019.129.038a.38.38 0 0 1 .11.071c.034.032.074.075.118.129l3.295 4.166a8.933 8.933 0 0 1-.038-.742v-3.672h1.42v6.938h-.839a.772.772 0 0 1-.314-.057.672.672 0 0 1-.248-.21l-3.271-4.133c.01.12.017.24.024.357.006.115.01.223.01.324v3.72h-1.42v-6.939h.848Zm10.217 1.41a.585.585 0 0 1-.152.171.325.325 0 0 1-.2.057.522.522 0 0 1-.238-.066 9.226 9.226 0 0 0-.286-.158 2.137 2.137 0 0 0-.362-.152 1.41 1.41 0 0 0-.466-.072c-.302 0-.527.066-.676.196a.652.652 0 0 0-.22.519c0 .14.045.255.134.347.089.093.205.172.347.239.147.066.312.128.496.185.187.054.377.116.571.186.194.067.383.146.567.238.187.092.352.21.495.352.146.143.264.318.352.524.09.203.134.45.134.738 0 .321-.056.621-.167.9-.111.28-.273.524-.486.734-.21.206-.47.37-.78.49a2.936 2.936 0 0 1-1.053.176 3.42 3.42 0 0 1-.662-.066 4.104 4.104 0 0 1-.648-.186 3.93 3.93 0 0 1-.59-.29 2.503 2.503 0 0 1-.48-.372l.475-.752a.419.419 0 0 1 .352-.19.53.53 0 0 1 .286.09 66 66 0 0 0 .329.2c.124.073.265.14.424.2.159.06.346.09.562.09.292 0 .519-.063.68-.19.162-.13.243-.335.243-.615a.579.579 0 0 0-.133-.395 1.024 1.024 0 0 0-.352-.252 3.132 3.132 0 0 0-.49-.176 18.272 18.272 0 0 1-.567-.167 4.595 4.595 0 0 1-.567-.229 1.893 1.893 0 0 1-.495-.357 1.727 1.727 0 0 1-.348-.552 2.212 2.212 0 0 1-.133-.82 1.966 1.966 0 0 1 .619-1.424 2.24 2.24 0 0 1 .747-.461 2.73 2.73 0 0 1 1.015-.176c.212 0 .419.017.619.052a3 3 0 0 1 .576.148c.18.063.35.141.505.233.158.09.3.19.423.305l-.4.748Zm-25.53 14.615a2.326 2.326 0 0 0 .915-.178v-.895h-.583a.283.283 0 0 1-.203-.068.23.23 0 0 1-.072-.174v-.753h2.096v2.49a3.1 3.1 0 0 1-.473.286 3.062 3.062 0 0 1-.522.195c-.184.051-.38.089-.591.113a5.821 5.821 0 0 1-.672.036 2.978 2.978 0 0 1-2.153-.858 2.978 2.978 0 0 1-.632-.955 3.147 3.147 0 0 1-.227-1.202c0-.44.073-.843.219-1.21a2.75 2.75 0 0 1 .623-.956c.273-.267.6-.474.984-.623a3.572 3.572 0 0 1 1.29-.222c.247 0 .477.02.693.06.216.04.414.096.595.166a2.722 2.722 0 0 1 .907.567l-.397.603a.433.433 0 0 1-.137.134.312.312 0 0 1-.17.048.474.474 0 0 1-.252-.08 3.508 3.508 0 0 0-.307-.167 1.69 1.69 0 0 0-.292-.117c-.1-.03-.205-.051-.315-.065a3.095 3.095 0 0 0-.373-.02 1.69 1.69 0 0 0-.692.137c-.205.09-.38.216-.526.381a1.746 1.746 0 0 0-.332.595c-.078.23-.117.486-.117.769 0 .313.043.591.13.834.086.243.204.448.355.615.154.167.335.295.543.385.21.086.44.13.688.13Zm8.07.988h-1.06a.51.51 0 0 1-.296-.081.444.444 0 0 1-.158-.215l-.348-1.028h-2.242l-.348 1.028a.462.462 0 0 1-.445.295h-1.069l2.283-5.897h1.4l2.283 5.898Zm-3.788-2.255h1.61l-.542-1.615a40.201 40.201 0 0 0-.125-.36c-.046-.14-.092-.292-.138-.453a8.04 8.04 0 0 1-.263.821l-.542 1.607Zm5.232.073v2.182h-1.368v-5.898h1.918c.426 0 .79.045 1.089.134.302.086.548.208.737.364.191.157.33.342.416.555.087.213.13.445.13.696 0 .191-.026.372-.077.542-.051.17-.128.328-.23.474a1.73 1.73 0 0 1-.373.384 1.944 1.944 0 0 1-.506.28c.092.046.177.102.255.17.081.067.151.15.21.247l1.255 2.052h-1.238c-.23 0-.394-.087-.494-.26l-.98-1.711a.408.408 0 0 0-.153-.162.497.497 0 0 0-.243-.049h-.348Zm0-.943h.55c.186 0 .344-.023.474-.069a.878.878 0 0 0 .323-.198.75.75 0 0 0 .183-.292c.037-.113.056-.234.056-.364 0-.259-.085-.461-.255-.607-.167-.146-.427-.219-.78-.219h-.551v1.749Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.685 35.932h-1.06a.51.51 0 0 1-.296-.081.444.444 0 0 1-.158-.215l-.348-1.028h-2.242l-.348 1.028a.462.462 0 0 1-.445.295h-1.07l2.284-5.897h1.4l2.283 5.898Zm-3.789-2.255h1.611l-.542-1.615a40.201 40.201 0 0 0-.125-.36c-.046-.14-.092-.292-.138-.453a8.04 8.04 0 0 1-.263.821l-.543 1.607Zm4.584-3.643c.06 0 .11.003.15.008a.372.372 0 0 1 .11.033.326.326 0 0 1 .093.06c.03.027.063.064.101.11l2.801 3.541a7.515 7.515 0 0 1-.032-.63v-3.122h1.206v5.898h-.712a.658.658 0 0 1-.268-.049.572.572 0 0 1-.21-.178l-2.78-3.513.02.303c.005.097.008.19.008.276v3.16H33.76v-5.897h.72Zm9.277 0v1.085h-1.66v4.813H40.73v-4.813h-1.66v-1.085h4.688Zm1.656 5.898h-1.376v-5.898h1.376v5.898Zm4.487-5.898v1.053h-2.42v1.376h1.854v1.012H47.48v1.404h2.42v1.053h-3.796v-5.898h3.797Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.394,
    y: 0.298,
    width: 59.213,
    height: 59.213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.905
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.952
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 18.095,
    y: 39.429,
    width: 22.857,
    height: 3.81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.476,
    dy: -0.476
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.238
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 44.762,
    y: 43.238,
    width: 11.429,
    height: 11.429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.952,
    dy: 0.952
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.952
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 1.336,
    y: 27.048,
    width: 57.307,
    height: 11.905,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.476
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTzg);
export default __webpack_public_path__ + "static/media/tzg.2e2d2d8a434ef42782b0da62429e9de5.svg";
export { ForwardRef as ReactComponent };